import { Extension } from '@tiptap/core'

export default Extension.create({
  name: 'fontSize',
  addOptions() {
    return {
      types: ['textStyle'],
      initialFontSize: 16,
      fontSizeUnit: 'px',
      fontSizeFactor: 1
    }
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: element => {
              const value = parseFloat(
                element.style.fontSize.replace(new RegExp(`${this.options.fontSizeUnit}$`, 'g'), '')
              )

              if (isNaN(value)) return this.default

              return Math.round(value * this.options.fontSizeFactor)
            },
            renderHTML: attributes => {
              if (!attributes.fontSize) {
                return {}
              }
              return {
                style: `font-size: ${attributes.fontSize / this.options.fontSizeFactor}${this.options.fontSizeUnit}`
              }
            }
          }
        }
      }
    ]
  },
  addCommands() {
    return {
      setFontSize:
        fontSize =>
        ({ chain }) => {
          return chain().setMark('textStyle', { fontSize }).run()
        },
      unsetFontSize:
        () =>
        ({ chain }) => {
          return chain().setMark('textStyle', { fontSize: null }).removeEmptyTextStyle().run()
        }
    }
  }
})
